import { createContext, useContext } from 'react'

/** 0 = full mobile header, 1 = collapsed (scroll-driven). Desktop / reduced-motion: always 0. */
export const HeaderCollapseProgressContext = createContext(0)

export function useHeaderCollapseProgress(): number {
  return useContext(HeaderCollapseProgressContext)
}
